export default Object.freeze({
  GRAPHOMETRIC_SIGNATURE: "signature_graphometric",
  GRAPHOMETRIC_OTP_SIGNATURE: "signature_graphometric_otp",
  SIGNATURE: "signature",
  CAPTURE: "capture",
  RADIO_BUTTON: "radiobutton",
  CHECKBOX: "checkbox",
  COMBOBOX: "combobox",
  TEXTFIELD: "textfield",
  SINGLE_CLICK_SIGNATURE: "single_click_signature"
});